import React, { useState } from "react";
import "../../style/popupform.css";
import moment from "moment";
import { Col, DatePicker, Form, Input, Modal, Row } from "antd";
import TextArea from "antd/lib/input/TextArea";

const CreateShortTermGoals = ({ formData, onSave, onCancel, onDelete, deleteGoal }) => {
  const [formState, setFormState] = useState({
    stepName: formData?.goalTitle || "",
    goal: formData?.goal || "",
    startDate: formData?.startdate ? moment(formData.startdate) : null,
    // startDate: formData?.startdate ? new Date(formData.startdate) : null,
    endDate: formData?.enddate ? moment(formData.enddate) : null,
    id: formData?.id ? formData.id : null,
    stepId: formData?.stepId ? formData.stepId : null
  });
  const [form] = Form.useForm();
  console.log('sss formData1', formState, formData, onDelete, deleteGoal)

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const onSubmit = (values) => {
    
    const formattedValues = {
      ...values,
      stepName: values.stepName?.trim(),
      goal: values.goal?.trim(),
      startDate: values.startDate ? moment(values.startDate).format("MMM D, YYYY") : "",
      endDate: values.endDate ? moment(values.endDate).format("MMM D, YYYY") : "",
      id: formData?.id || null,
      stepId: formData?.stepId || null,
    };
    onSave(formattedValues);
    // console.log('sss formattedValues', formattedValues, values)
  }

  return (
    <>

    <Modal
      title=""
      footer={null}
      visible={true}
      onCancel={onCancel}
      width="590px"
      // closeIcon={<CloseOutlined className="close-icon" />}
    >
      <h2 className="modal-title">{ formState.id ? "Edit Short Term Goals" : "Create Short Term Goals" }</h2>
      <Form
        form={form}
        name="short_term_goals_form"
        onFinish={onSubmit}
        initialValues={formState}
        layout="vertical"
        >
        {/* Step Name Title */}
        <Form.Item label="Step Name" name="stepName" className="goal-stepName" rules={[{ required: true, message: "Required Field" }]}> 
          <Input placeholder="Enter Step Name" />
        </Form.Item>

        {/* Goal */}
        <Form.Item label="Goal" name="goal" className="goal-desc" rules={[{ required: true, message: "Required Field" }]}> 
          <TextArea placeholder="Enter goal" autoSize={{ minRows: 2, maxRows: 5 }} />
        </Form.Item>

        {/* Start Date & End Date */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Start Date" name="startDate" className="goal-startDate" rules={[{ required: true, message: "Required Field" }]}> 
              <DatePicker format="MM/DD/YYYY" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="End Date" name="endDate" className="goal-endDate" rules={[
                { required: true, message: "Required Field" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const startDate = getFieldValue("startDate");
                    if (!value || !startDate || value.isAfter(startDate)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("End Date must be after Start Date"));
                  },
                }),
              ]}> 
              <DatePicker format="MM/DD/YYYY" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>

        {/* Buttons */}
        <Row justify="space-between">
          <Col span={12}>
          {
            deleteGoal ? (

                <button
                  style={{
                    color: "red",
                    textDecoration: "underline",
                    backgroundColor: "white",
                    border: "none",
                    padding: "10px 15px",
                    fontSize: "17px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    onDelete(formState.id, formState.stepId)
                  }}
                  >
                  {"Delete"}
                </button>
            ) : null
          }
          </Col>
          <Col span={12}>
            <Row>
              <Col span={11}>
                <button className="button-secondary" onClick={onCancel} style={{width: "100%"}}>Cancel</button>
              </Col>
              <Col span={2}></Col>
              <Col span={11}>
                <button className="button-main" style={{width: "100%"}}>Save</button>
              </Col>
            </Row>
          </Col>
        </Row>

      </Form>

    </Modal>
    

      {/* <div className="modal-overlay">
        <div className="modal-form">
          <h2 className="modal-title">Create Short Term Goals</h2>

          <div className="form-group">
            <label className="form-label">Step Name</label>
            <input
              type="text"
              name="stepName"
              value={formState.stepName}
              onChange={handleChange}
            className="form-textarea-goal"
              placeholder="Enter step name"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Goal</label>
            <textarea
              name="goal"
              value={formState.goal}
              onChange={handleChange}
              className="form-textarea-goal"
              placeholder="Enter Goal"
              rows={4}
              style={{
                height: "70px"
              }}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={formState.startDate}
              onChange={handleChange}
            className="form-textarea-goal"
            />
          </div>

          <div className="form-group">
            <label className="form-label">End Date</label>
            <input
              type="date"
              name="endDate"
              value={formState.endDate}
              onChange={handleChange}
              className="form-textarea-goal"
            />
          </div>

          <div className="button-group">
            <button className="button-secondary" style={{width: "25%"}} onClick={onCancel}>Cancel</button>
            <button className="button-main" style={{width: "25%"}} onClick={() => onSave(formState)}>Save</button>
          </div>
        </div>
      </div> */}

    </>
  );
};

export default CreateShortTermGoals;
